/**
 * Small inline SVG icons. Static strings only, so they are safe to assign to a
 * map marker's innerHTML; nothing here ever contains user input.
 */

export const HOUSE_SVG =
  '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11.5 12 4l9 7.5"/><path d="M5.5 10v9.5h4.5v-5.5h4v5.5h4.5V10"/></svg>';

/** A person: head and shoulders. Used for "you are here". */
export const PERSON_SVG =
  '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="currentColor"><circle cx="12" cy="7.5" r="3.6"/><path d="M4.6 20.2c.5-4.3 3.3-6.6 7.4-6.6s6.9 2.3 7.4 6.6c.05.5-.3.8-.8.8H5.4c-.5 0-.85-.3-.8-.8z"/></svg>';

export const PIN_SVG =
  '<svg viewBox="0 0 24 32" width="24" height="32" aria-hidden="true"><path d="M12 1C6.2 1 1.5 5.6 1.5 11.3 1.5 19 12 31 12 31s10.5-12 10.5-19.7C22.5 5.6 17.8 1 12 1z" fill="currentColor" stroke="#fff" stroke-width="2"/><circle cx="12" cy="11.3" r="3.6" fill="#fff"/></svg>';

interface IconProps {
  size?: number;
  className?: string;
}

const wrap = (svg: string, size: number | undefined, className: string | undefined) => (
  <span
    className={className}
    style={{ display: 'inline-flex', width: size, height: size, lineHeight: 0 }}
    aria-hidden="true"
    dangerouslySetInnerHTML={{ __html: svg }}
  />
);

export const HouseIcon = ({ size, className }: IconProps) => wrap(HOUSE_SVG, size, className);
export const PersonIcon = ({ size, className }: IconProps) => wrap(PERSON_SVG, size, className);
export const PinIcon = ({ size, className }: IconProps) => wrap(PIN_SVG, size, className);
